export const parsePlatformId = (platformId: string): string[] => {
  if (platformId !== null && platformId.includes(',')) {
    return platformId.split(',')
  } else {
    return [platformId]
  }
}
